export const kebabToCamelCase = string => string.replace(/([-_]\w)/g, g => g[1].toUpperCase());
export const kebabToSnakeCase = string => string.replace(/([-])/g, () => '_');
export const camelToSnakeCase = string => string.replace(/[A-Z]+(?![a-z])|[A-Z]/g, (g, ofs) => (ofs ? '_' : '') + g.toLowerCase());
export default string => {
  const camelCase = kebabToCamelCase(string);
  return `${camelCase[0].toUpperCase()}${camelCase.substring(1)}`;
};
//# sourceMappingURL=notationConverter.js.map